module.exports = __webpack_public_path__ + "img/logo2.ca09fa54.png";